<template>
  <div class="container">
    <section class="header">
      账单详情
    </section>
    <van-list>
      <template v-if="list && list.length > 0">
        <van-cell
          v-for="(item,index) in list"
          :key="index"
          class="cell-card"
          :title="formatTime(item.billMonth)"
          :label="`GTV：¥${item.divideGtv}元`"
          label-class="label"
          is-link
          @click.stop="$emit('click-cell', item.billMonth)"
        />
      </template>
      <van-cell
        v-else
        title="暂无数据"
        title-class="no-data"
      />
    </van-list>
  </div>
</template>

<script>
import { formatYearMonth } from '@/util/filter';

export default {
  name: 'ConditionPayBill',
  props: {
    list: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    formatTime(billMonth) {
      if (billMonth) {
        return formatYearMonth(billMonth);
      }
      return billMonth;
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  padding: 0.36rem;
  .header{
    font-weight: bold;
    font-size: 0.36rem;
  }

  .label {
    padding-left: 0.4rem;
    color:#323233;
  }

  .no-data {
    text-align: center;
  }
}
</style>
